import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { universalMFAQueryKeys } from '../constants/queryKeys';
import { apiGet } from '../../../../api/queries/apiGet';
import { API_BASE_URL } from '../constants/consts';
import { QueryFilters } from '../types';
import { buildUniversalMfaQueryParams } from '../constants/utils';
import { ProtocolTypeSummary } from '../../types';

const END_POINT = '/metric/protocolType';

export type ProtocolTypeSummaryDto = ProtocolTypeSummary;

const convertToProtocolTypeSummary = (data: ProtocolTypeSummaryDto): ProtocolTypeSummary => {
    return data;
};

const fetchProtocolTypeSummary = async (filters: QueryFilters) => {
    const data = await apiGet<ProtocolTypeSummaryDto>(
        `${API_BASE_URL}${END_POINT}`,
        buildUniversalMfaQueryParams(filters)
    );

    return data;
};

export const useProtocolTypeSummary = (filters: QueryFilters): UseQueryResult<ProtocolTypeSummary> => {
    return useQuery({
        queryKey: universalMFAQueryKeys.protocolTypeSummary(filters),
        queryFn: () => fetchProtocolTypeSummary(filters),
        select: convertToProtocolTypeSummary
    });
};
